import { Card, Field } from "@/components/kit";
import { Stepper } from "@/components/Stepper";
import { StickPhoto } from "@/components/StickPhoto";

export const VerifyInputs = ({ s, patch, ullage, setUllage, t }) => (
  <Card testID="verify-inputs">
    <div className="inputs inputs-tight">
      <Field label={t("Starting stick")}>
        <Stepper blank testID="verify-start" unit="in" decimal step={0.125} max={s.diameter} value={s.startInches} onValue={(v) => patch({ startInches: v })} />
        <StickPhoto testid="verify-start" max={s.diameter} onValue={(v) => patch({ startInches: v })} />
      </Field>
      <Field label={t("Metered delivery")}>
        <Stepper blank testID="verify-delivered" unit="gal" step={50} max={40000} value={s.dropGallons} onValue={(v) => patch({ dropGallons: v })} />
      </Field>
      <Field label={t("Tank diameter")}>
        <Stepper testID="verify-diameter" unit="in" decimal step={1} min={30} max={240} value={s.diameter} onValue={(v) => patch({ diameter: v })} />
      </Field>
      <Field label={t("Tank size (full)")}>
        <Stepper testID="verify-capacity" unit="gal" step={500} min={100} max={80000} value={s.capacity} onValue={(v) => patch({ capacity: v })} />
      </Field>
      <Field label={t("Console ullage (room before the drop, optional)")}>
        <Stepper blank testID="verify-ullage" unit="gal" step={50} max={80000} value={ullage} onValue={setUllage} />
      </Field>
    </div>
    <div className="seg" data-testid="verify-ends">
      <button type="button" className={s.ends === "dome" ? "seg-on" : ""} onClick={() => patch({ ends: "dome" })} data-testid="verify-ends-dome">{t("Fiberglass (rounded ends)")}</button>
      <button type="button" className={s.ends === "flat" ? "seg-on" : ""} onClick={() => patch({ ends: "flat" })} data-testid="verify-ends-flat">{t("Steel (flat ends)")}</button>
    </div>
  </Card>
);
